<template>
  <div>
    <top-nav></top-nav>
    <div class="page_content">
      <p class="details_title">关于我们</p>
      <p class="details_info">辽宁省体育局前身为辽宁省体委。新中国成立初期，辽宁地区行政建制包括辽东、辽西两省和沈阳、旅大、鞍山、抚顺、本溪5个大区直辖市。</p>
      <div class="pic_con">
        <img src="@/assets/image/gywm.png"/>
      </div>
      <p class="details_info">
        1953年，两省5市相继建立了体育运动委员会，列入省市人民行政机构序列。东北行政区撤销后，于1954年8月1日，辽东、辽西两省合并，辽宁省体育运动委员会正式成立，统管全省体育工作。副省长车向忱兼任省体委主任。
      </p>
      <p class="details_info">
        为适应国防体育发展的需要，1956年经省人委批准建立与省体委并列的辽宁省国防体育协会，编制36人。1959年6月，国防体协和省体委合并。省体委机关设群众体育处、国防体育处、海空体育处、竞赛处、秘书科、宣传科，编制45人。
      </p>
      <p class="details_info">
        为加强对体育工作的领导，1960年6月省委书记胡亦民担任省体委主任，李道之任副主任。1976年以后，省体委主任不再由省级领导同志兼任，省体委机关设办公室、人事处、群体处、竞赛处、训练教育处、军体处、计财处，在政治处改为人事处的同时，成立了省体委机关党委。
      </p>
      <p class="details_info">
        进入80年代，体育事业发展较快。1984年前后，在机构改革中，部分县区体委被合并到教委、文教部门。1985年8月，省委、省政府联合发出了《关于进一步发展辽宁省体育运动的通知》，要求各县仍保留体委建制。全省有13个市和100个县、区都建立了体委。
      </p>
      <div class="pic_con">
        <img src="@/assets/image/gywmdz.png"/>
      </div>
      <p class="details_info">
        2000年1月，根据国务院机构改革精神，更名为辽宁省体育局，为省政府直属机构。现位于沈阳市东陵区浑南四路8号。 省体育局现共有37个单位。其中局机关处室11个：办公室、政策法规处、群体处、竞体处、经财处、人事（外事）处、机关党委、监察室、老干部处、科教处、青少处。
      </p>

    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "aboutUs"
}
</script>

<style scoped lang="less">
.page_content {
  padding: 19px 100px 0px 100px;

  p {
    margin: 0;
    padding: 0;
  }

  .details_title {
    font-size: 48px;
    color: #333;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .details_info {
    font-weight: 400;
    font-size: 24px;
    color: #000;
    margin-bottom: 20px;
    text-indent:2em
  }

  .details_point {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    padding: 0 0 0 20px;
    text-align: left;
    text-justify: unset;
    line-height: 40px;
  }
}

.pic_con {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  img {
    width: 60%;
  }
}

</style>
